import { configService } from '@/settings/api-url'
import configWebsocket from '../../../settings/ws-url'
const actions = {
  action_getLastOrder (context, data) {
    configService('/orders/not_id?last_order=true')
      .then((response) => {
        context.commit('CURRENT_ORDER', response.data)
      })
  },
  async action_getOrders ({ commit, dispatch }, payload = {
    perPage: 5,
    page: 1
  }) {
    await configService(`/orders?per_page=${payload.perPage}&page=${payload.page}`)
      .then((response) => {
        if(response.data) {
          if(response.data.orders) {
            commit('ORDERS', response.data.orders)
          }
          if(response.data.meta && response.data.meta.pagination) {
            commit('ORDERS_META', response.data.meta.pagination)
          }
        }
      })
  },
  action_getCurrentOrder ({ commit, dispatch }, data) {
    configService(`/orders/${data}`)
      .then((res) => {
        const { data } = res
        commit('CURRENT_ORDER', data)
        commit('LOGS', data.logs)
        // dispatch('action_evaulateOrder')
        return res
      })
  },
  action_getTransaction({ commit, dispatch }, data) {
    configService(`/transactions/${data}`)
      .then((res) => {
        const { data } = res
        commit('CURRENT_ORDER_PAYMENT', data)
        return res
      })
  },
  action_evaulateOrder ({ commit, dispatch, state }) {
    // dispatch('action_getAnswers')
    // if (state.currentOrder.status === 'order_completed' && state.currentOrder.answers.length === 0) {
    //   state.idActionCable.unsubscribe()
    // }
    // else {
    //   dispatch('action_realTimeAction')
    // }
    // if (!state.currentOrder.is_takeout) {
    //   dispatch('action_getChallengueIns')
    // }
  },
  // action_realTimeAction ({ commit, dispatch, state, getters }) {
  //   commit('ID_ACTION_CABLE', configWebsocket.subscriptions.create({ channel: 'UserOrderWatcherChannel', user_id: getters.getUser.id }, {
  //     connected: function (res) {
  //     },
  //     disconnected: function () {
  //     },
  //     received: function (res) {
  //       if (state.currentOrder.id === res.id) {
  //         commit('CURRENT_ORDER', res)
  //         dispatch('action_getAnswers')
  //         dispatch('action_notifyOrderAction')
  //       }
  //     }
  //   }))
  // },
  action_notifyOrderAction ({ commit, state }) {
    if (('Notification' in window)) {
      if (Notification.permission === 'granted') {
        let options = {
          icon: 'https://m.enlau.co/missing/logo-marca-morado.png',
          body: this.$t(state.currentOrder.status + '.message.' + state.currentOrder.commerce.type)
        }
        // eslint-disable-next-line
        let notification = new Notification(`ID ${state.currentOrder.id} - ${state.$t(state.currentOrder.status + '.state.' + state.currentOrder.commerce.type)}`, options)
      } else if (Notification.permission !== 'denied') {
      }
    }
  }
}

export default actions
